import styled from 'styled-components';

const Wrapper = styled.div`
  padding: 50px 0 120px;
`;

export default Wrapper;
